import { queryCourseDetail } from '@/api'
// import download from '@/plugins/download'
import { Toast, ImagePreview } from 'vant'
export default {
  components: {},
  props: [],
  name: 'attachment',
  data () {
    return {
      c: {},
      loading: false,
      courseId: null
    }
  },
  computed: {
    // x: function() {}
  },
  watch: {
    // x: function(val) {}
  },
  created () {
    const courseId = this.$route.query.id
    if (courseId === undefined || courseId === null || courseId === '') {
      this.$message({ type: 'error', message: '数据错误，请联系管理员检查' })
    } else {
      this.courseId = courseId
    }
    this.initData()
  },
  mounted () {},
  destroyed () {},
  methods: {
    async initData () {
      this.loading = true
      const courseResult = await queryCourseDetail(this.courseId)
      const { data } = courseResult
      this.c = data
      this.loading = false
    },
    copy () {
      Toast('链接复制成功，您可以去粘贴了')
    },
    onClickLeft () {
      this.$router.back(-1)
    },
    openLink (url) {
      window.open(url)
    },
    toShare () {
      this.$router.push({ path: '/share', query: { id: this.courseId } })
    },
    openImg (url) {
      ImagePreview({ images: [url], closeable: true })
    }
  }
}
